'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = count;

var _actions = require('./actions');

var _util = require('@its/util');

var initialState = {
  locale: (navigator.language || navigator.userLanguage).split('-')[0],
  messages: {}
};

function count() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actions.SET_LOCALE:
      return (0, _util.merge)(state, {
        locale: action.payload
      });
    case _actions.SET_MESSAGES:
      return (0, _util.merge)(state, {
        messages: action.payload
      });
    case _actions.SET_LOCALE_AND_MESSAGES:
      return (0, _util.merge)(state, action.payload);
    default:
      return state;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/IntlProviderContainer/reducer.js
 ** module id = 471
 ** module chunks = 0
 **/